// import Lottie from 'lottie-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

// import newLoader from '../../../assets/newLoader.json';

export function PendingMessage() {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });

  // if (isUnity)
  //   return (
  //     <div className="success-wrapper">
  //       <section className="success">
  //         <div>
  //           <Lottie animationData={newLoader} style={{ height: 100 }} size={100} />
  //         </div>
  //         <motion.h1
  //           style={{
  //             padding: 0,
  //             margin: 0,
  //             fontSize: '16px',
  //           }}
  //         >
  //           {t('processing')}
  //         </motion.h1>
  //       </section>
  //     </div>
  //   );
  // }

  return (
    <div className="success-wrapper">
      <section className="success" style={{ width: 'fit-content' }}>
        <motion.h1
          style={{
            padding: 0,
            margin: 0,
          }}
        >
          {t('processing')}
        </motion.h1>
        <motion.h4
          style={{
            padding: 0,
            margin: 0,
          }}
        >
          {t('thisWillOnlyTakeAFewMoments')}
        </motion.h4>
        <div
          style={{
            marginTop: '0.5em',
          }}
        >
          <span className="loader"></span>
        </div>
      </section>
    </div>
  );
}
